import { render, staticRenderFns } from "./BlUpload.vue?vue&type=template&id=563f46de&"
import script from "./BlUpload.vue?vue&type=script&lang=js&"
export * from "./BlUpload.vue?vue&type=script&lang=js&"
import style0 from "./BlUpload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BlUpload.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports